export const NAVIGATION_LINKS = [
  { href: "#welcome", label: "About Me" },
  { href: "#skills", label: "Skills" },
  { href: "#portfolio", label: "Project" },
  { href: "#contact", label: "Contact" }
];

export const SOCIAL_LINKS = [
  {
    platform: 'github',
    url: 'https://github.com/harryng',
    icon: 'faGithub'
  },
  {
    platform: 'linkedin',
    url: 'https://linkedin.com/in/hainnp',
    icon: 'faLinkedin'
  }
];

export const skillsData = [
  { logo: "/Python_Icon.png", name: "Python" },
  { logo: "/Javascript_Icon.png", name: "JavaScript" },
  { logo: "/React_Icon.png", name: "React" },
  { logo: "/Java_Icon.png", name: "Java" },
  { logo: "/Docker_Icon.png", name: "Docker" },
  { logo: "/Postgres_Icon.png", name: "Postgres" },
  { logo: "/Redis_Icon.png", name: "Redis" },
  { logo: "/TS_Icon.png", name: "TypeScript" },
  { logo: "/MongoDB_Icon.png", name: "mongoDB" },
  { logo: "/MySql_Icon.png", name: "MySQL" },
  { logo: "/MUI_Icon.png", name: "Material UI" },
  { logo: "/Git_Icon.png", name: "Git" },
  { logo: "/Agile_Icon.png", name: "Agile" },
];

export const projectsData = [
  {
    title: "Tukko",
    link: "https://github.com/reimbo/tukko",
    description: "Full-stack public APIs Finnish Traffic Visualizer",
    techStack: ["React", "TypeScript", "Docker", "mongoDB", "Agile", "Frontend", "Backend", "Map", "WimmaLab"],
    image: "/Tukko.png", 
  },
  {
    title: "FinInNote",
    link: "https://harryng-github-io.vercel.app/PM-Webpage/index.html",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a leo bibendum, aliquet nunc eget, commodo tellus.",
    techStack: ["JavaScript", "Agile", "Frontend"],
    image: "/FinInNote.jpg", 
  },
  {
    title: "Ally's Kitchen",
    link: "https://harryng-github-io.vercel.app/allykitchen/index.html",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a leo bibendum, aliquet nunc eget, commodo tellus.",
    techStack: ["React", "Postgres", "Git", "Client", "Design", "Frontend"],
    image: "/AllyKitchen.jpg", 
  },
  {
    title: "The Rosa",
    link: "https://harryng-github-io.vercel.app/the-rosa/index.html",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a leo bibendum, aliquet nunc eget, commodo tellus.",
    techStack: ["JavaScript", "Personal", "Frontend"],
    image: "/TheRosa.jpg", 
  },
  {
    title: "Dumulix",
    link: "https://harryng-github-io.vercel.app/Dumulix/index.html",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a leo bibendum, aliquet nunc eget, commodo tellus.",
    techStack: ["JavaScript", "Client", "Logistics", "Design", "Frontend"],
    image: "/Dumulix.jpg", 
  },
  {
    title: "Bank Management System",
    link: "https://github.com/HarryNg/HaiNg-Hands-On/blob/main/Python-Projects/bankManagement-storage/bankManagement.py",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a leo bibendum, aliquet nunc eget, commodo tellus.",
    techStack: ["Python", "Backend", "Personal", "School"],
    image: "/Loading_Icon.jpg", 
  },
  {
    title: "Employee Management System",
    link: "https://github.com/HarryNg/HaiNg-Hands-On/tree/main/Python-Projects/employeeMnt",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a leo bibendum, aliquet nunc eget, commodo tellus.",
    techStack: ["Python", "Backend", "Personal", "School"],
    image: "/WorkInProgress.png", 
  },
  
]; 

